import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideMenuItemSizeDescription',
  initialState: false,
  reducers: {
    setHideMenuItemSizeDescription(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHideMenuItemSizeDescription } = slice.actions;

export default slice.reducer;
